import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

export const submitLearningFeedbackAPI = async (data) => {
  try {
    const response = await apiService.post(endpoints.submitLearningFeedback, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLearningFeedbackListAPI = async ({ page = 1, limit = 10, search = "", from_date = "", to_date = "" } = {}) => {
  try {
    const params = { page, limit, search };
    if (from_date) params.from_date = from_date;
    if (to_date) params.to_date = to_date;
    const response = await apiService.get(endpoints.getLearningFeedbackList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLearningFeedbackByIdAPI = async (id) => {
  try {
    const endpoint = endpoints.getLearningFeedbackById.replace("{id}", id);
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteLearningFeedbackAPI = async (id) => {
  try {
    const endpoint = endpoints.deleteLearningFeedback.replace("{id}", id);
    const response = await apiService.delete(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};
